import "core-js/modules/web.dom-collections.iterator.js";
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
const middlewares = [thunk];
composeWithDevToolsDevelopmentOnly(applyMiddleware(thunk));
if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
  middlewares.push(logger);
}
const enhancers = [applyMiddleware(...middlewares)];
const store = createStore(rootReducer, undefined, composeWithDevToolsDevelopmentOnly(...enhancers));
export default () => store;